module.exports = __webpack_public_path__ + "img/1.f3706d9d.jpg";